export default {
    "driverStatusCreateEdit_editTitle": "Update",
    "driverStatusCreateEdit_createTitle": "Create driver status",
    "driverStatusCreateEdit_success": "Success",
    "driverStatusCreateEdit_successMessage": "Driver status saved",
    "driverStatusCreateEdit_name": "Name",
    "driverStatusCreateEdit_notAllowedName": "This name is not available",
    "driverStatusCreateEdit_accumulateTime": "Accumulation Time"
};